import { stringify } from "qs";
import axios from 'axios';
/**
 *
 *  App Banner
 *
 *  */
document.addEventListener('click', function (event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-download-app")) {
        return;
    }

    // Prevent default link behavior
    event.preventDefault();
    let source = el.getAttribute('data-source');
    let action = el.getAttribute('data-action');
    let link = el.getAttribute('data-link');

    axios({
        url: '/backend/landing/download_app_log',
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: stringify({
            source: source,
            action: action
        }),
    }).then(() => {
        if (action === 'download') {
            window.location.href = link.replace(/lang_pref=(en|af)/, '').replace(/lang=(en|af)/, '').replace(/#.*/, "");
        } else {
            document.getElementById('js-download-app-banner').classList.add('d-none');
        }
    });

},false);
